import DATA_MODEL_TABLE from "./dataModelTable";

const ACTION_LOGS_DATA_MODEL = {
  actionDate: {
    key: "actionDate",
    value: "Action date"
  },
  actionTime: {
    key: "actionTime",
    value: "Action time"
  },
  actionType: {
    key: "action",
    value: "Action type"
  },
  gxpReady: {
    key: "gxpReady",
    value: DATA_MODEL_TABLE?.gxpReady?.value
  },
  gxpReadyCluster: {
    key: "gxpReadyCluster",
    value: DATA_MODEL_TABLE?.gxpReady?.value
  },
  systemStatusCluster: {
    key: "systemStatusCluster",
    value: DATA_MODEL_TABLE?.systemStatus?.value
  },
  systemStatus: {
    key: "systemStatus",
    value: DATA_MODEL_TABLE.systemStatus.value
  },
  materialNumber: {
    key: "materialNumber",
    value: "Material number"
  },
  ecrNumber: {
    key: "ecrNumber",
    value: "ECR number"
  },
  status: {
    key: "status",
    value: DATA_MODEL_TABLE.status.value
  },
  softwareVerison: {
    key: "updatedSoftwareVersion",
    value: "Software version"
  },
  configurationDetails: {
    key: "logbookConfigurationDetails",
    value: "Configuration details"
  },
  configurationBaseline: {
    key: "logbookConfigurationBaseline",
    value: "Configuration baseline"
  },
  approveStatus: {
    key: "approveStatus",
    value: "Approve status"
  }
};

export default ACTION_LOGS_DATA_MODEL;
